import React from 'react';
import Scrollbar from "react-scrollbars-custom";
import PropTypes from 'prop-types';
import './index.less'
const CustomScrollBar = (props) =>
    <div style={props.containerStyle} className={props.className}>
        <Scrollbar
            noScrollX={props.noScrollX} noDefaultStyles disableTracksWidthCompensation style={{ position: "" }}  >
            {props.children}
        </Scrollbar>
    </div>
CustomScrollBar.propTypes = {
    children: PropTypes.any.isRequired,
    noScrollX: PropTypes.bool.isRequired
}
export default CustomScrollBar;


// WEBPACK FOOTER //
// ./src/components/common/CustomScrollBar/index.jsx